import Copy from './Copy'

export default Copy
// eslint-disable-next-line import/export
export * from './Copy'
